<app-left-side-nav *ngIf="!isLoading"></app-left-side-nav>
<app-header></app-header>

<!-- page content area start -->
<div *ngIf="!isLoading" class="HomePage">
    <div id="carouselExampleCaptions" class="carousel slide">
        <!-- Indicators -->
        <div class="carousel-indicators d-none">
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0"
                class="active"></button>
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1"></button>
            <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2"></button>
        </div>

        <!-- Slides -->
        <div class="carousel-inner">

            <!-- Slide 1 -->
            <div class="carousel-item active">
                <img src="/assets/images/slide1.png" class="w-100 desktop-view slider-img" alt="First Slide">
                <img src="/assets/images/slide1-mobile.png" class="w-100 mobile-view slide-height" alt="First Slide">
                <div class="overlay"></div>
                <div class="carousel-caption d-md-block">
                    <!-- <h5 class="text-medium">INDIA'S LARGEST</h5>
                    <h1 class="text-large">AGRI SHOW</h1> -->
                    <img src="/assets/images/text-img.png" class="mb-4 text-image" />
                    <div class="mb-4">
                        <p class="text-small mb-0">KISAN is india’s largest agriculture trade fair.</p>
                        <p class="text-small">It brings together the entire agri-community</p>
                    </div>
                    <div class="d-flex flex-column venue mb-4">
                        <span class="mb-2"><i class="fa-regular fa-calendar me-3"></i> 9 Dec - 13 Dec 2026</span>
                        <span class="mb-2"><i class="fa-solid fa-location-dot me-3"></i> PIECC, Moshi, Pune</span>
                    </div>
                    <div class="mobile-div">
                        <button class="button" (click)="onBuyTickets()" *ngIf="showBuyTicketButton"><span>Buy Tickets</span>
                            <span><i class="fa fa-arrow-right"></i></span>
                        </button>
                        <button class="button myTkt" (click)="onViewTickets()"
                            *ngIf="isAssigned && isAuthenticated && eventDetails?.event_status !== 'over'"><span>View Ticket</span>
                            <span><i class="fa fa-arrow-right"></i></span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Slide 2 -->
            <div class="carousel-item d-none">
                <img src="/assets/images/slide2.png" class="w-100 desktop-view slider-img" alt="Second Slide">
                <img src="/assets/images/slide2-mobile.png" class="w-100 mobile-view slide-height" alt="Second Slide">
                <div class="overlay"></div>
                <div class="carousel-caption d-md-block">
                    <h1 class="text-large">
                        <span>Connect With</span>
                        <span>Exhibitors</span>
                    </h1>
                    <ul class="text-small mb-4">
                        <li>Explore the list of exhibitors.</li>
                        <li>Send connection request.</li>
                    </ul>
                    <button class="button"><span>Coming Soon</span>
                        <span><i class="fa fa-arrow-right"></i></span>
                    </button>
                </div>
            </div>

            <!-- Slide 3 -->
            <div class="carousel-item d-none">
                <img src="/assets/images/slide3.png" class="w-100 desktop-view slider-img" alt="Third Slide">
                <img src="/assets/images/slide3-mobile.png" class="w-100 mobile-view slide-height" alt="Third Slide">
                <div class="overlay"></div>
                <div class="carousel-caption d-md-block">
                    <h1 class="text-large">
                        <span>Explore 1000+</span>
                        <span>Plus Agri Products</span>
                    </h1>
                    <p class="text-small mb-4">Find product of your interest with just a tap.</p>
                    <button class="button"><span>Coming Soon</span>
                        <span><i class="fa fa-arrow-right"></i></span>
                    </button>
                </div>
            </div>

        </div>

        <!-- Controls -->
        <button class="carousel-control-prev d-none" type="button" data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev">
            <span class="carousel-control-prev-icon"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next d-none" type="button" data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next">
            <span class="carousel-control-next-icon"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>
    <section class="pavilionS pt-5">
        <div class="container pt-1">
            <div class="timer">
                <div class="d-flex align-items-center justify-content-end wrapper">
                    <div class="buysec">
                        <img class="ministry-logo" src="/assets/images/ministry-logo.png" alt="ministry-logo" />
                    </div>
                    <div class="d-flex justify-content-end pt-3" id="countdown" *ngIf="!isEventStarted">
                        <div class="time">
                            <span>{{ days }}</span> <br>
                            <label>Days</label>
                        </div>
                        <span class="dot">:</span>
                        <div class="time">
                            <span>{{ hours }}</span><br>
                            <label>Hours</label>
                        </div>
                        <span class="dot">:</span>
                        <div class="time">
                            <span>{{ minutes }}</span><br>
                            <label>Minutes</label>
                        </div>
                        <span class="dot">:</span>
                        <div class="time">
                            <span>{{ seconds }}</span><br>
                            <label>Seconds</label>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="inviteSec d-flex align-items-center justify-content-between my-4 flex-column flex-md-row"
                *ngIf="this.inviteList.length > 0">
                <div>
                    <div class="text-center mb-3 mobile-view">
                        <img src="/assets/images/pending-icon.png" alt="invitation" width="50px" />
                    </div>
                    <h2 class="font-weight-600">Pending Invitations</h2>

                    <p class="mb-0">
                        You have {{ this.inviteList.length }}
                        {{ this.inviteList.length == 1 ? 'invitation' : 'invitations' }}
                        pending.
                    </p>
                </div>
                <button class="acceptBtn" (click)="navigateToAcceptInvite()">View Invitation</button>
            </div>
            <div class="pavilion-wrapper" [ngClass]="{'d-none': hidePavilionSection}" *ngIf="eventDetails?.show_digital_catalog">
                <div class="layout d-flex justify-content-between flex-column flex-md-row">
                    <h3 class="tit" [class.reduce-padding]="isEventStarted">Dedicated Pavilions <br
                        class="d-md-none d-sm-block">At KISAN</h3>
                    <div class="">
                        <a (click)="viewLayout()" class="button"><span>Exhibition Layout</span>
                            <span><i class="fa fa-arrow-right"></i></span>
                        </a>
                    </div>    
                </div>
                
                <div class="mSection d-flex" *ngIf="!isLoadingPavilions && allPavilions?.length">
                    <div class="grp pragati">
                        <div class="pGrp">
                            <div class="sng" *ngFor="let pavilion of allPavilions">
                                <div class="img-Wrapper">
                                    <img [src]="pavilion.image_url" [alt]="pavilion.name"
                                    (click)="onClickPavilion(pavilion)"
                                    (keydown.enter)="onClickPavilion(pavilion)"
                                    tabindex="0"
                                    role="button"/>
                                </div>
                                <h6 class="text-center mt-2 text-white"
                                    (click)="onClickPavilion(pavilion)"
                                    (keydown.enter)="onClickPavilion(pavilion)"
                                    tabindex="0"
                                    role="button">{{ pavilion.name }}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-loader text-left" *ngIf="isLoadingPavilions">
                    <div class="spinner-border text-success" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="virtual-pass-section" *ngIf="eventDetails?.event_status !== 'over'">
        <div class="container">
            <div class="virtual-pass-inner" (click)="onJoinVirtualEvent()">
                <div class="row">
                    <div class="image col-md-5">
                        <img src="/assets/images/Mobile-Pass.png" class="" />
                    </div>
                    <div class="col-md-7">
                        <div class="content">
                            <div *ngIf="shouldShowGetMobilePass()">
                                <h1 class="tit">Kisan On Your Mobile</h1>
                                <h4 class="virtual_subtitle mb-0">Get a mobile pass <span
                                        class="virtual_amount">₹ 100</span>
                                    free</h4>
                                <p class="virtual_description mb-0">Access India's largest agri show with your smart
                                    phone
                                </p>
                            </div>
                            <div *ngIf="shouldShowExploreKisanOnMobile()">
                                <h1 class="tit"><i class="fa fa-circle-check"></i> Your mobile pass for KISAN Agri
                                    Show is now
                                    active.
                                </h1>
                            </div>
                            <button class="button" (click)="onJoinVirtualEvent()">
                                <span *ngIf="shouldShowExploreKisanOnMobile()">Explore
                                    KISAN on Mobile</span>
                                <span *ngIf="shouldShowGetMobilePass()">Get
                                    Mobile Pass</span>
                                <span><i class="fa fa-arrow-right"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="section-wrapper">
        <!-- exhibitor section -->
        <section class="exhibitorSec">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="content">
                            <h1 class="tit">Exhibitor</h1>
                            <div class="image-outer mobile-view">
                                <img src="/assets/images/exh-mobile.png" class="" />
                            </div>
                            <ul>
                                <li>Connect with leading companies & organisations in agriculture</li>
                                <li>Establish new connections and Expand your network.</li>
                            </ul>
                            <button class="button" (click)="onClickCatalog()" *ngIf="eventDetails?.show_digital_catalog"><span>Explore</span>
                                <span><i class="fa fa-arrow-right"></i></span>
                            </button>
                        </div>
                    </div>
                    <div class="col-md-6 text-end desktop-view">
                        <div class="image-outer">
                            <img src="/assets/images/exh-mobile.png" class="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Product section -->
        <section class="product-section">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 desktop-view">
                        <div class="image-outer">
                            <img src="/assets/images/agri-product.png" />
                        </div>
                    </div>
                    <div class="col-md-6 desktop-alignment">
                        <div class="content">
                            <h1 class="tit">Find Agri Product</h1>
                            <div class="image-outer mobile-view">
                                <img src="/assets/images/agri-product.png" />
                            </div>
                            <ul>
                                <li>Explore wide range of agri-products.</li>
                                <li>Discover solutions for modern farming needs.</li>
                            </ul>
                            <button class="button" (click)="onClickCatalog()" *ngIf="eventDetails?.show_digital_catalog"><span>View More</span>
                                <span><i class="fa fa-arrow-right"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- shortlist and save section -->
        <div class="shortlist-section background-prop py-5">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="content">
                            <h1 class="tit">Shortlist & Save</h1>
                            <div class="image-outer mobile-view">
                                <img src="/assets/images/exh-mobile.png" />
                            </div>
                            <ul class="list">
                                <li>Companies and products shortlisted by you are here.</li>
                                <li>Your personalized shortlist page for easy review and planning.</li>
                            </ul>
                            <button class="button" (click)="onClickCatalog()" *ngIf="eventDetails?.show_digital_catalog"><span>View More</span>
                                <span><i class="fa fa-arrow-right"></i></span>
                            </button>
                        </div>
                    </div>
                    <div class="col-md-6 text-end desktop-view">
                        <div class="image-outer">
                            <img src="/assets/images/exh-mobile.png" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Special offer section -->
        <section class="special-offer-section">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 desktop-view">
                        <div class="image-outer">
                            <img src="/assets/images/contact-exh.png" />
                        </div>
                    </div>
                    <div class="col-md-6 desktop-alignment">
                        <div class="content">
                            <h1 class="tit">Contact Exhibitors</h1>
                            <div class="image-outer mobile-view">
                                <img src="/assets/images/contact-exh.png" />
                            </div>
                            <ul>
                                <li>Get in touch with the exhibitors you are interested in.</li>
                                <li>Start a dialogue before you visit KISAN.</li>
                            </ul>
                            <button class="button" (click)="onClickCatalog()" *ngIf="eventDetails?.show_digital_catalog"><span>View More</span>
                                <span><i class="fa fa-arrow-right"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Digital Catalogue Section -->
        <section class="digital-Catalogue-section background-prop">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="content">
                            <h1 class="tit">Digital Catalogue</h1>
                            <div class="image-outer mobile-view">
                                <img src="/assets/images/digital-catalogue.png" />
                            </div>
                            <ul>
                                <li>Load your multimedia catalogues on the KISAN platform.</li>
                                <li>Host all the information about your organisation and products.</li>
                            </ul>
                            <button class="button" (click)="onClickCatalog()" *ngIf="eventDetails?.show_digital_catalog"><span>Explore</span>
                                <span><i class="fa fa-arrow-right"></i></span>
                            </button>
                        </div>
                    </div>
                    <div class="col-md-6 text-end desktop-view">
                        <div class="image-outer">
                            <img src="/assets/images/digital-catalogue.png" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Inbox Section -->
        <section class="inbox-section d-none">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 desktop-view">
                        <div class="image-outer">
                            <img src="/assets/images/inbox.png" />
                        </div>
                    </div>
                    <div class="col-md-6 desktop-alignment">
                        <div class="content">
                            <h1 class="tit">Inbox</h1>
                            <div class="image-outer mobile-view">
                                <img src="/assets/images/inbox.png" />
                            </div>
                            <ul>
                                <li>Receive messages, notifications and offers from Exhibitors & KISAN.</li>
                                <li>Stay tuned with the latest messages, alerts, and special offers.</li>
                            </ul>
                            <button class="button"><span>Coming Soon</span>
                                <span><i class="fa fa-arrow-right"></i></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         <section class="Voting-section" *ngIf="isContestActive">
        <div class="container">
            <div class="virtual-pass-inner" (click)="onClickVote()">
                <div class="row">
                    <div class="image col-md-5">
                    </div>
                    <div class="col-md-7">
                        <div class="content">
                            <div>
                                <h1 class="tit">Vote for Innovation</h1>
                                <p class="virtual_description mb-0">KISAN Quest is a series of contests designed to discover 
                                    smart, practical ideas for agriculture and rural life. 
                                    Vote online for the ideas you believe are truly futuristic.
                                </p>
                            <button class="button" (click)="onClickVote()">
                                <span>{{isVotingActive ? 'Vote Now' : 'Explore Ideas'}}</span>
                                <span><i class="fa fa-arrow-right"></i></span>
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
        <!-- Kisan Initiatives Section -->
        <section class="initiatives-section">
            <div class="container">
                <h1 class="tit">Kisan Initiatives</h1>
                <div class="row">
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div class="card">
                            <img src="/assets/images/quest-logo.png" class="mb-3 img-responsive" alt="kisan Quest">
                            <img src="/assets/images/quest.png" class="card-img-top" alt="kisan quest">
                            <div class="card-body px-0">
                                <p class="card-text">
                                    KISAN Quest is a series of contests to discover smart, practical ideas for
                                    agriculture and rural life.Winning entries will be showcased at the KISAN
                                    Exhibition.
                                </p>
                            </div>
                            <div class="card-body pt-0 px-0 d-flex justify-content-start align-items-end">
                                <a href="https://www.kisan.quest/" target="_blank" class="page-link"><i
                                        class="fa fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-none">
                        <div class="card">
                            <img src="/assets/images/kisan-new-logo.png" class="w-50 mb-3 img-responsive"
                                alt="kisan New Logo">
                            <img src="/assets/images/kisan-new.png" class="card-img-top" alt="kisan new">
                            <div class="card-body px-0">
                                <p class="card-text">
                                    A platform to launch everything new in agriculture. Technologies, ideas,
                                    innovations, products, initiatives & startups. Come, share what’s New.
                                </p>
                            </div>
                            <div class="card-body pt-0 px-0 d-flex justify-content-start align-items-end">
                                <a href="https://new.kisan.in/" target="_blank" class="page-link"><i
                                        class="fa fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div class="card">
                            <img src="/assets/images/agricorp_logo.png" class="w-50 mb-3 img-responsive"
                                alt="kisan Agricorp Logo">
                            <img src="/assets/images/agricrop_banner.jpg" class="card-img-top" alt="Agricorp">
                            <div class="card-body px-0">
                                <p class="card-text">The AgriCorp Conference, organised by the Bombay Chamber of 
                                    Commerce & Industry is  a key platform for fostering collaboration, knowledge-sharing, 
                                    and strategic planning to drive the growth and advancement of India’s agricultural economy.</p>
                            </div>
                            <div class="card-body px-0 pt-0 d-flex justify-content-start align-items-end">
                                <a href="https://pune.kisan.in/sanket" target="_blank" class="page-link"><i
                                        class="fa fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                        <div class="card pb-0">
                            <img src="/assets/images/jagar-logo.png" class="w-50 mb-3 img-responsive"
                                alt="kisan Jagar Logo">
                            <img src="/assets/images/jagar.png" class="card-img-top" alt="jagar">
                            <div class="card-body px-0">
                                <p class="card-text">
                                    This effort builds awareness on key issues in the agriculture and farming
                                    community.
                                    It encourages informed dialogue and action among farmers, experts, and
                                    stakeholders.
                                </p>
                            </div>
                            <div class="card-body px-0 pt-0 d-flex justify-content-start align-items-end">
                                <a href="https://pune.kisan.in/jagar" target="_blank" class="page-link"><i
                                        class="fa fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    
   
    <section class="location">
        <div class="container">
            <h3 class="tit">Venue</h3>
            <div class="map">
                <a href="https://maps.app.goo.gl/FiCjwgQoqaBtSS6z6" target="_blank">
                    <img src="/assets/images/map.png" class="w-100 desktop-view" />
                    <img src="/assets/images/map-mobile.png" class="w-100 mobile-view" />
                    <div class="location-info">
                        <p class="address">PIECC, Sector No. 5,<br />
                            Moshi, Pimpri-Chinchwad,<br />
                            Maharashtra 412105.</p>

                        <p class="date mb-0">9 to 13 Dec'26, Pune</p>
                        <p class="time mb-0">Time: 9 AM to 5 PM</p>

                    </div>
                </a>
            </div>
        </div>
    </section>
    <section class="footSec">
        <div class="container">
            <div class="foot">
                <h2 class="mb-0">Explore, Discover, and Grow.<br>Plan your visit now.</h2>
                <div class="btn-wrapper">
                    <button class="button" (click)="onBuyTickets()" *ngIf="showBuyTicketButton"><span>Buy Tickets</span>
                        <span><i class="fa fa-arrow-right"></i></span>
                    </button>
                    <button class="button myTkt" (click)="onViewTickets()"
                        *ngIf="isAssigned && isAuthenticated && eventDetails?.event_status !== 'over'"><span>View Ticket</span>
                        <span><i class="fa fa-arrow-right"></i></span>
                    </button>

                </div>
            </div>
        </div>
    </section>
</div>
<!-- Success Modal - Virtual Events -->
<div class="modal fade" id="virtualPassModal" tabindex="-1" aria-labelledby="LoyaltyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content green">
            <div class="text-end">
                <button type="button" class="btn" (click)="goToVirtualEvent()" data-bs-dismiss="modal"><i
                        class="fa-solid fa-xmark green"></i></button>
            </div>
            <div class="modal-body text-center mt-3">
                <h1 class="mb-4 fw-bold">Congrats!<br> You have virtual <br>access. </h1>

                <img class="mb-3" src="/assets/images/loyalty.gif" />
                <p class="mb-4">Start exploring the digital<br> catalog now. </p>

                <button class="font-weight-600 mt-3" (click)="goToVirtualEvent()" data-bs-dismiss="modal">Start
                    Exploring</button>
            </div>
        </div>
    </div>
</div>

<!-- invitation Modal -->
<div #invitationModal class="modal" id="invitationModal" tabindex="-1" aria-labelledby="invitationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
            <div class="inviteSec text-center">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div>
                    <div class="text-center mb-3 mobile-view">
                        <img src="/assets/images/pending-icon.png" alt="invitation" width="60px" />
                    </div>
                    <h2 class="font-weight-600 mt-4">Pending Invitations</h2>

                    <p class="mb-0">
                        You have {{ inviteList.length }}
                        {{ inviteList.length === 1 ? 'invitation' : 'invitations' }}
                        pending.
                    </p>
                </div>
                <button class="acceptBtn mt-3" (click)="navigateToAcceptInvite()">View Invitation</button>
            </div>
        </div>
  </div>
</div>